import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <Helmet><title>404 – Page Not Found | Vedonica International</title></Helmet>
      <div className="notfound-page">
        <div className="notfound__inner">
          <div className="notfound__icon"></div>
          <h1 className="notfound__code">404</h1>
          <h2 className="notfound__title">Page Not Found</h2>
          <p className="notfound__subtitle">
            The page you're looking for seems to have wandered off into the forest.
          </p>
          <div className="notfound__actions">
            <Link to="/" className="btn btn-primary">Go Home</Link>
            <Link to="/product/vedonica-ayurvedic-wellness-oil" className="btn btn-outline">Shop Now</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
